import { render, staticRenderFns } from "./crudSurrender.vue?vue&type=template&id=2cdb601d&scoped=true&"
import script from "./crudSurrender.vue?vue&type=script&lang=js&"
export * from "./crudSurrender.vue?vue&type=script&lang=js&"
import style0 from "./crudSurrender.vue?vue&type=style&index=0&id=2cdb601d&prod&lang=css&"
import style1 from "./crudSurrender.vue?vue&type=style&index=1&id=2cdb601d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb601d",
  null
  
)

export default component.exports